import Input from '@/components/Input/Input';

export type { InputProps } from '@/components/Input/InputTypes';
export default Input;
